import { useMemo } from 'react';
import MeetingItem from 'commons/components/items/MeetingItem';
import Section from 'commons/components/section/Section';
import { isMeetingPast } from 'commons/libs/meeting_utils';
import { MEETING_STATUSES } from 'commons/types/meetingsTypes';
import { useMeetingList } from 'stores/meetings/meetingsHooks';

export default function PastSchedules() {
  const [meetings] = useMeetingList();
  const pastMeetings = useMemo(
    () =>
      meetings
        ?.filter((meeting) => isMeetingPast(meeting))
        .filter((meeting) => meeting.status !== MEETING_STATUSES.REFUNDED) ||
      [],
    [meetings],
  );
  const cancelledMeetings = useMemo(
    () =>
      meetings?.filter(
        (meeting) => meeting.status === MEETING_STATUSES.REFUNDED,
      ) || [],
    [meetings],
  );
  return (
    <div className='flex flex-col items-center grow space-y-3'>
      <Section
        title='Mes rendez-vous réalisés'
        childrens={
          pastMeetings.map((meeting) => (
            <MeetingItem
              key={meeting.id}
              meeting={meeting}
            />
          )) || []
        }
      />
      <Section
        title='Mes rendez-vous annulés'
        childrens={
          cancelledMeetings.map((meeting) => (
            <MeetingItem
              key={meeting.id}
              meeting={meeting}
            />
          )) || []
        }
      />
    </div>
  );
}
